import { SvgIcon, SvgIconProps } from "@mui/material";

export const CalenderTimerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15 3v2M7 3v2M3 9h16M19 10V7a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h4M17.393 15.983v1.758l1.382.843"
      />
      <path
        stroke="currentColor"
        strokeWidth="1.5"
        d="M17.5 22a4.5 4.5 0 0 1-4.5-4.5c0-2.434 2.07-4.503 4.504-4.5a4.5 4.5 0 0 1-.004 9"
      />
    </svg>
  </SvgIcon>
);
